<template>
  <div></div>
</template>

<script>

import {mapGetters} from 'vuex';

export default {
  name: 'MessageModal',
  data() {
    return {
      notificationToasts: this.$toasted.group({
        position: 'top-center',
        singleton: true,
        containerClass: 'container',
        action: [
          {
            text: 'Do not show again',
            onClick: this.dontShowModalAgain,
            class: 'action-hide'
          },
          {
            text: 'OK',
            onClick: this.hide,
            class: 'action-ok'
          }
        ],
        className: 'toast-item'
      })
    }
  },
  computed: {
    ...mapGetters('map', ['network', 'technology', 'listMessages']),
    messageForNetworkAndTechnology: function () {
      // check: is there  message for this combination of operator and tech
      return this.network && this.technology ? this.listMessages.find((message) => message.operator.id === this.network.id &&
        message.technology.id === this.technology.id) : null
    }
  },
  watch: {
    'messageForNetworkAndTechnology': {
      handler: function (message) {
        const messageToasts = this.$toasted.groups[0].toasts;
        if (message) {
          // check is such message in list dismissed
          const disabledMessages = this.getObjFromStorage('disabledMessages')
          const foundMessageInDisabledList = disabledMessages[message.title]

          if (!foundMessageInDisabledList || foundMessageInDisabledList !== message.message) {
            this.show(message.message)

            if (foundMessageInDisabledList && foundMessageInDisabledList !== message.message) {
              const {[message.title]: previousMessage, ...restState} = disabledMessages
              localStorage.setItem('disabledMessages', JSON.stringify(restState))
            }
          } else {
            if (messageToasts.length) messageToasts[0].goAway(0)
          }
        } else {
          if (messageToasts.length) messageToasts[0].goAway(0)
        }
      },
      immediate: true
    }
  },
  methods: {
    hide(e, toastObject) {
      toastObject.goAway(0)
    },
    dontShowModalAgain(e, toastObject) {
      if (this.messageForNetworkAndTechnology) this.setMessagesToStorage('disabledMessages', this.messageForNetworkAndTechnology)
      this.hide(e, toastObject)
    },
    getObjFromStorage(itemName) {
      const dataFromStorage = localStorage.getItem(itemName);
      const disabledMessages = dataFromStorage ? JSON.parse(dataFromStorage) : {};

      return disabledMessages;
    },
    setMessagesToStorage(itemName, message) {
      // add the message to disabledMessages list
      const objectMessages = this.getObjFromStorage(itemName)
      objectMessages[message.title] = message.message

      localStorage.setItem(itemName, JSON.stringify(objectMessages))
    },
    show(v) {
      this.notificationToasts.show(v)
    }
  }
}
</script>

<style>
:root {
  --modalWidth: 360px;
}

.toasted-container.top-center.container {
  top: 40%;
}

@media only screen and (max-width: 600px) {
  .toasted-container.top-center.container {
    top: 35%;
    left: calc(50% - var(--modalWidth) / 2);
  }
}

@media only screen and (max-device-width: 600px) {
  .toasted-container.top-center.container {
    top: 35%;
    left: calc(50% - var(--modalWidth) / 2);
  }
}

.toast-item.toasted.toasted-primary {
  display: block;
  position: relative;
  font-family: "Open Sans";
  font-size: 16px;
  font-weight: 400;
  line-height: 140%;
  letter-spacing: 0.25px;
  word-break: break-word;
  background-color: white;
  color: black;
  width: var(--modalWidth);
  box-sizing: border-box;
  padding: 16px 16px 60px;
  min-height: unset;
  box-shadow: -1px 2px 12px 2px rgba(0, 0, 0, 0.25)
}

.toast-item.toasted.toasted-primary .action.ripple {
  font-size: 14px;
  line-height: 16px;
  font-weight: 500;
  color: #018478;
  text-transform: none;
  padding: 10px 16px;
  margin: 0px;
  position: absolute;
  bottom: 8px;
}

.action.ripple.action-ok {
  right: 0px;
  letter-spacing: 1.25px;
}

.action.ripple.action-hide {
  left: 0px;
  letter-spacing: 0.5px;
}

</style>
